import { render, staticRenderFns } from "./sp-input.vue?vue&type=template&id=9632d49a&scoped=true"
import script from "./sp-input.vue?vue&type=script&lang=js"
export * from "./sp-input.vue?vue&type=script&lang=js"
import style0 from "./sp-input.vue?vue&type=style&index=0&id=9632d49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9632d49a",
  null
  
)

export default component.exports